var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrowCircledTopLeft = function SvgArrowCircledTopLeft(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46439 14.1212C7.46439 14.6735 7.91211 15.1212 8.46439 15.1212C9.01667 15.1212 9.46439 14.6735 9.46439 14.1212L9.46439 10.8786L14.8284 16.2425C15.2189 16.6331 15.852 16.6331 16.2426 16.2425C16.6331 15.852 16.6331 15.2189 16.2426 14.8283L10.8786 9.46437L14.1212 9.46437C14.6735 9.46437 15.1212 9.01665 15.1212 8.46437C15.1212 7.91208 14.6735 7.46437 14.1212 7.46437L8.46439 7.46437C7.91211 7.46437 7.46439 7.91208 7.46439 8.46437L7.46439 14.1212Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34314 17.6568C9.46734 20.781 14.5327 20.781 17.6569 17.6568C20.781 14.5326 20.781 9.46726 17.6569 6.34307C14.5327 3.21888 9.46734 3.21887 6.34315 6.34307C3.21895 9.46726 3.21895 14.5326 6.34314 17.6568ZM4.92893 19.071C8.83417 22.9762 15.1658 22.9762 19.0711 19.071C22.9763 15.1657 22.9763 8.8341 19.0711 4.92886C15.1658 1.02361 8.83418 1.02361 4.92893 4.92886C1.02369 8.8341 1.02369 15.1657 4.92893 19.071Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })))));
};
export { SvgArrowCircledTopLeft as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-circled-top-left.6f20023a.svg";